export default "__VITE_PUBLIC_ASSET__91927f46__"